/**
 * Government Intake Selectors
 *
 * Memoized selectors for accessing intake state.
 */

import type { RootState } from '@/store';

export const selectIntakePayload = (state: RootState) => state.governmentIntake?.intakePayload;

export const selectCurrentStep = (state: RootState) => state.governmentIntake?.currentStep ?? 0;

export const selectCompletedSteps = (state: RootState) => state.governmentIntake?.completedSteps ?? [];

export const selectIntakeId = (state: RootState) => state.governmentIntake?.intakeId;
